import clsx from "clsx";

import { SubscriptionPlanIcon } from "common/components/subscriptions";
import { PRICING_PLANS } from "common/constants";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { JSX, ReactNode } from "react";

export default function SubscriptionDetailsCard({
  plan,
  footerComponent,
  tagComponent,
  priceComponent,
  mainComponent,
  className,
}: {
  plan: keyof typeof PRICING_PLANS;
  footerComponent: JSX.Element;
  tagComponent: JSX.Element;
  priceComponent: JSX.Element;
  mainComponent?: JSX.Element;
  className?: string;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { name, altDescription } = PRICING_PLANS[plan];

  const headingComponent = (
    <div className="flex-1 flex flex-col gap-y-0.5">
      <div className="flex items-center gap-x-1">
        <h3 className="text-lg-bold">{name}</h3>

        {tagComponent}
      </div>

      <p className="text-sm-medium text-black-500">{altDescription}</p>
    </div>
  );

  let mainContent: ReactNode;
  if (isDesktop) {
    mainContent = (
      <>
        <div className="flex items-start gap-x-3">
          <SubscriptionPlanIcon plan={plan} size="md" />
          {headingComponent}
          {priceComponent}
        </div>

        {mainComponent && <div className="flex gap-x-3">{mainComponent}</div>}
      </>
    );
  } else {
    mainContent = (
      <>
        <div className="flex gap-x-3 justify-between mb-1">
          <SubscriptionPlanIcon plan={plan} size="lg" />
          {priceComponent}
        </div>

        {headingComponent}

        {mainComponent}
      </>
    );
  }

  return (
    <section
      className={clsx(
        "flex flex-col gap-y-3 lg:gap-y-4 rounded-5xl lg:rounded-3xl border border-black-200 p-3 lg:p-4",
        className,
      )}
    >
      {mainContent}

      {/* Separator */}
      <span className="border-t-2 border-dotted border-black-200" />

      {footerComponent}
    </section>
  );
}
